export default __webpack_public_path__ + "static/media/Savant's Bands of the Moon.06a2c3a1.jpg";